import { render, staticRenderFns } from "./FiguresDrawer.vue?vue&type=template&id=72dfecee"
import script from "./FiguresDrawer.vue?vue&type=script&lang=js"
export * from "./FiguresDrawer.vue?vue&type=script&lang=js"
import style0 from "./FiguresDrawer.vue?vue&type=style&index=0&id=72dfecee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports